import MenuItem from 'records/MenuItem';
import Base from 'records/Base';

import {
  MENU_ITEM_ASYNC_ACTION_START,
  MENU_ITEM_ASYNC_ACTION_ERROR,
  MENU_ITEM_ASYNC_UPDATE_ACTION_SUCCESS,
  MENU_ITEM_UPDATE_ACTION_SUCCESS,
  MENU_ITEM_ARCHIVE_ACTION_SUCCESS,
  MENU_ITEM_RESET_STATE,
} from 'actions/menuItem';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new MenuItem(),
});

const actionsMap = {
  [MENU_ITEM_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ITEM_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ITEM_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new MenuItem(action.data),
    });
  },
  [MENU_ITEM_ARCHIVE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [MENU_ITEM_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return new Base({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [MENU_ITEM_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menuItem(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
